import { Card } from "react-bootstrap";
import * as R from "ramda";
import React, { useCallback, useState } from "react";
import { StateSetter } from "../utils/types";
import { MdClose } from "react-icons/md";
import { IconButton } from "../Components/IconButton";
import "./Tray.scss";
import { VideoInfo } from "./videoTutorialUtils";
import VideoContainer from "./VideoContainer";
import FullScreenVideo from "./FullScreenVideo";
interface TrayProps {
  videoList?: VideoInfo[] | undefined;
  setShowExpandedTray: StateSetter<boolean>;
}

const Tray: React.FC<TrayProps> = ({ videoList, setShowExpandedTray }) => {
  const [currentVideo, setCurrentVideo] = useState<VideoInfo>();
  const [fullScreenVideo, setFullScreenVideo] = useState<boolean>(false);

  const updateCurrentVideo = useCallback(
    (video: VideoInfo) => {
      if (videoList && videoList.length > 0) {
        const currentIndex = R.findIndex(R.propEq("title", video.title), videoList);
        setCurrentVideo(videoList[currentIndex]);
      }
    },
    [videoList]
  );
  const createVideoContainers = (videoList: VideoInfo[]): any => {
    let containerList = R.map(
      video => (
        <VideoContainer
          key={video.title}
          videoContent={video}
          onFullScreenClick={updateCurrentVideo}
          setFullScreenVideo={setFullScreenVideo}
        />
      ),
      videoList
    );
    return containerList;
  };

  return (
    <>
      <Card className="trayContainer">
        <Card.Header className="trayHeader">
          <div className="trayTextAndButton">
            <div className="trayText">Help Center</div>
            <div className="widgetBox">
              <IconButton
                className="trayCloseButtonBox"
                variant="outline-white"
                onClick={() => setShowExpandedTray(false)}
                icon={<MdClose className="trayCloseButton" />}
              >
                {""}
              </IconButton>
            </div>
          </div>
        </Card.Header>
        <Card.Body className="trayBody">
          {videoList && videoList.length > 0 ? (
            createVideoContainers(videoList)
          ) : (
            <p>No videos available</p>
          )}
        </Card.Body>
      </Card>
      <FullScreenVideo
        currentVideo={currentVideo}
        setFullScreenVideo={setFullScreenVideo}
        fullScreenVideo={fullScreenVideo}
        videoList={videoList}
      ></FullScreenVideo>
    </>
  );
};

export default Tray;
